import {
  selectAdditionalLanguages,
  selectDefaultLanguageCode,
  selectLanguageCodes,
  selectLanguagesMetadata,
} from '@polyai/stream/store/reducers/languages/selector';
import type { LanguagesState } from '@polyai/stream/store/reducers/languages/types';

import { useAppSelector } from 'hooks/reduxHooks';

export const useLanguagesEventSourcing = () => {
  const languages: LanguagesState = useAppSelector(state => state.languages);
  const defaultLanguageCode = useAppSelector(selectDefaultLanguageCode);

  const selectedAdditionalLanguages = useAppSelector(selectAdditionalLanguages);
  const additionalLanguages =
    selectedAdditionalLanguages?.ids && selectedAdditionalLanguages.ids.length
      ? Object.values(selectedAdditionalLanguages.entities).filter(
          (lang): lang is NonNullable<typeof lang> => lang != null,
        )
      : [];
  const languageCodes = useAppSelector(selectLanguageCodes);
  const languagesMetadata = useAppSelector(selectLanguagesMetadata);

  const isLoadingLanguages =
    !languages.defaultLanguageCode &&
    (languages.additionalLanguages?.ids?.length ?? 0) === 0;

  const hasAdditionalLanguages = additionalLanguages.length > 0;

  return {
    languages,
    defaultLanguageCode,
    additionalLanguages,
    hasAdditionalLanguages,
    languageCodes,
    languagesMetadata,
    isLoadingLanguages,
  };
};
